module.exports = __webpack_public_path__ + "static/media/miffy_lin.0c829c28.jpg";